import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  InjectionToken,
  Input,
  // eslint-disable-next-line no-restricted-imports
  signal,
  Type,
  ViewChild,
} from '@angular/core';

import { IconComponent } from '../../../../common/icon/icon.component';
import { IconName } from '../../../../icons-container/icons.type';
import { InputComponent } from '../../../input/input.component';
import { NgTemplateLifecycleDirective } from '../../utils/ng-template-lifecycle.directive';
import { Select2TriggerDirective } from './trigger.directive';

export const DEFAULT_TRIGGER_COMPONENT = new InjectionToken<Type<Select2TriggerComponent>>(
  'default trigger',
);

@Component({
  selector: 'rt-select-trigger',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    Select2TriggerDirective,
    InputComponent,
    NgTemplateLifecycleDirective,
    IconComponent,
    NgIf,
  ],
  template: `
    <ng-template rtSelectTrigger #triggerDir="triggerDir" let-selectCtrl let-inOverlay="inOverlay">
      <rt-input
        #inputCmp
        ngTemplateLifecycle
        (ngInit)="triggerDir.setFocusable(inputCmp.input)"
        [readOnly]="true"
        [placeholder]="placeholder()"
        [hasDropdownIndicator]="true"
        [class.dropdownOpened]="selectCtrl.isOpen$.value"
        [value]="selectCtrl.itemSelector.getSelectedItem()?.label ?? null"
        (click)="selectCtrl.toggle(true)"
        variant="rounded"
      >
        <rt-icon *ngIf="iconName()" prefix [name]="iconName()!"></rt-icon>
      </rt-input>
    </ng-template>
  `,
  styleUrls: ['./trigger-default.component.less'],
  providers: [
    {
      provide: Select2TriggerDirective,
      useFactory: () => inject(Select2TriggerComponent).directive,
    },
  ],
})
export class Select2TriggerComponent {
  @ViewChild(Select2TriggerDirective, { static: true })
  public directive: Select2TriggerDirective<null>;

  @Input() public placeholder = signal<string>('Option');
  @Input() public iconName = signal<IconName | null>(null);
}
